// Device list UI constants — storage keys, timeouts, shared CSS class names.

import {
  BTN_PRIMARY_SM,
  BTN_SECONDARY_SM,
  BTN_PRIMARY,
  BTN_SECONDARY,
  BTN_DARK,
  BTN_ICON,
  INPUT,
  INPUT_SM,
  SELECT,
  CHIP,
  REQUEST_FILTER_CHIP,
} from '../../shared/ui/uiTokens';

export const STORAGE_SEARCH_KEY = 'fleetmanager:deviceList:search';
export const STORAGE_MASTER_COLS_KEY = 'fleetmanager:deviceList:visibleMasterCols';
export const STORAGE_EXTRA_COLS_KEY = 'fleetmanager:deviceList:visibleExtraCols';

export const ONLINE_TIMEOUT_MS = 20_000;

export {
  BTN_PRIMARY,
  BTN_SECONDARY,
  BTN_DARK,
  BTN_ICON,
  INPUT,
  SELECT,
  CHIP,
  REQUEST_FILTER_CHIP,
};

export const BTN_PRIMARY_COMPACT = BTN_PRIMARY_SM;
export const BTN_SECONDARY_COMPACT = BTN_SECONDARY_SM;
export { INPUT_SM };
